module.exports = __webpack_public_path__ + "img/btn-phone.9c0c6b98.png";